
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns",
      function () {
        return require("private-next-pages/returns/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns"])
      });
    }
  